import styled from 'styled-components';

export const Item = styled.div`
  display: flex;
  align-items: center;
  gap: 90px;
  min-height: 40px;
  border-bottom: 1px solid #cfcfcf;
  padding: 0 10px;
`;

export const DateText = styled.p`
  font-size: var(--font-size13);
  font-weight: var(--font-weight500);
  line-height: 1.15;
  letter-spacing: 0.5px;
  color: var(--color-grey6A);
`;

export const Text = styled.p`
  font-size: var(--font-size18);
  line-height: 1.22;
  letter-spacing: 0.5px;
  color: var(--color-grey6A);
`;
